export type PlayerTextProps = {
  playerName: string;
  className?: string;
};

export default function PlayerText({ playerName, className = '' }: PlayerTextProps) {
  return (
    <p
      className={`w-full max-w-[72px] truncate text-center text-[10px] font-robotoMedium font-medium leading-[16px] text-pmw-label-primary-dark ${className}`}
      title={playerName}
    >
      {playerName}
    </p>
  );
}
